import React from "react";
import { Row, Col } from "./../../Grid";
import { SectionHeader } from "./../shared/components";
import AcceptedPayments from "./AcceptedPayments";
import BillingAddress from "./BillingAddress";
import CardNumber from "./CardNumber";
import CvcNumber from "./CvcNumber";
import ExpirationDate from "./ExpirationDate";
export function PaymentInformation(_ref) {
  var e = _ref.firstName,
      t = _ref.lastName,
      r = _ref.address,
      a = _ref.city,
      m = _ref.shippableStates,
      n = _ref.zipCode,
      o = _ref.phoneNumber,
      _ref$showHeader = _ref.showHeader,
      l = _ref$showHeader === void 0 ? !0 : _ref$showHeader,
      _ref$showPaymentDetai = _ref.showPaymentDetails,
      c = _ref$showPaymentDetai === void 0 ? !0 : _ref$showPaymentDetai,
      s = _ref.register,
      i = _ref.setValue,
      p = _ref.normalizePhone,
      d = _ref.errors;
  return React.createElement(React.Fragment, null, l && React.createElement(SectionHeader, {
    title: "Payment Information"
  }), React.createElement(Row, null, React.createElement(AcceptedPayments, null)), React.createElement(Row, null, React.createElement(BillingAddress, {
    errors: d,
    register: s,
    setValue: i,
    city: a,
    shippableStates: m,
    address: r,
    zipCode: n,
    lastName: t,
    firstName: e,
    phoneNumber: o,
    normalizePhone: p
  })), c && React.createElement(React.Fragment, null, React.createElement(Row, null, React.createElement(Col, null, React.createElement(CardNumber, {
    register: s,
    setValue: i,
    errors: d
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12,
    sm: 6
  }, React.createElement(ExpirationDate, {
    register: s,
    setValue: i,
    errors: d
  })), React.createElement(Col, {
    xs: 12,
    sm: 6
  }, React.createElement(CvcNumber, {
    register: s,
    setValue: i,
    errors: d
  })))));
}
export default PaymentInformation;